import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Auth Components
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';

// Creator Components
import CreatorDashboard from './components/Creator/Dashboard';
import ImportWizard from './components/Creator/ImportWizard';
import CurationConsole from './components/Creator/CurationConsole';
import PortfolioManager from './components/Creator/PortfolioManager';

// Recruiter Components
import RecruiterDashboard from './components/Recruiter/Dashboard';
import TalentSearch from './components/Recruiter/TalentSearch';
import PipelineManager from './components/Recruiter/PipelineManager';
import CandidateProfile from './components/Recruiter/CandidateProfile';

// Shared Components
import PrivateRoute from './components/Shared/PrivateRoute';

function App() {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    // Check for existing auth token
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/register" element={<Register onRegister={handleLogin} />} />

          {/* Creator Routes */}
          <Route
            path="/creator/dashboard"
            element={
              <PrivateRoute user={user} requiredType="creator">
                <CreatorDashboard user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/creator/import"
            element={
              <PrivateRoute user={user} requiredType="creator">
                <ImportWizard user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/creator/curation"
            element={
              <PrivateRoute user={user} requiredType="creator">
                <CurationConsole user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/creator/portfolio"
            element={
              <PrivateRoute user={user} requiredType="creator">
                <PortfolioManager user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />

          {/* Recruiter Routes */}
          <Route
            path="/recruiter/dashboard"
            element={
              <PrivateRoute user={user} requiredType="recruiter">
                <RecruiterDashboard user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/recruiter/search"
            element={
              <PrivateRoute user={user} requiredType="recruiter">
                <TalentSearch user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/recruiter/pipeline"
            element={
              <PrivateRoute user={user} requiredType="recruiter">
                <PipelineManager user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/recruiter/candidate/:id"
            element={
              <PrivateRoute user={user} requiredType="recruiter">
                <CandidateProfile user={user} onLogout={handleLogout} />
              </PrivateRoute>
            }
          />

          {/* Default Route */}
          <Route
            path="/"
            element={
              user ? (
                <Navigate to={`/${user.userType}/dashboard`} replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
